<div class="fixed bottom-4 right-4 z-50 flex flex-col gap-2 w-80">
  @for (toast of toasts; track toast.id) {
    <div
      class="flex items-start gap-3 p-4 rounded-lg shadow-lg text-white text-sm font-medium"
      [class]="toastClass(toast.type)"
    >
      <span class="flex-1">{{ toast.message }}</span>
      <button
        (click)="dismiss(toast.id)"
        class="opacity-70 hover:opacity-100 transition-opacity shrink-0"
      >
        <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
          <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
        </svg>
      </button>
    </div>
  }
</div>
